/* Cudeman · Selector de cuchillos · motor de recomendacion (v2)
   Mismo archivo para el tema (window.KFEngine) y para las pruebas en Node (module.exports).
   Solo usa datos reales de la ficha tecnica; nada se inventa. */
(function (root) {
  'use strict';

  var BUCKETS = { N: [7.5, 9.5], F: [9, 14], X: [8, 12] };       // limites pequeno | mediano | grande (hoja, cm)
  var PRES = { '50': [0, 50], '80': [50, 80], '120': [80, 120], '999': [120, 1e9] };
  var PREMIUM_NAT = /ciervo|asta|roseta|carnero|cocobolo/i;

  function has(p, re) { for (var i = 0; i < p.extras.length; i++) if (re.test(p.extras[i])) return true; return false; }

  // detalles imprescindibles (solo se preguntan a quien ya tiene experiencia)
  var DET = {
    funda:    function (p) { return p.funda; },
    cierre:   function (p) { return p.tipo === 'N' && !!p.cierre; },
    gruesa:   function (p) { return p.grosor >= 4.5; },
    enteriza: function (p) { return p.tipo === 'F' && p.ent; },
    bohler:   function (p) { return p.acero === 'boh'; },
    desollar: function (p) { return /desollador/i.test(p.punta) || has(p, /desollador/i); },
    percutor: function (p) { return has(p, /percutor|rompe ?cristales/i); },
    fuego:    function (p) { return has(p, /fuego|pedernal|chispa/i); },
    cordon:   function (p) { return has(p, /cord[oó]n/i); },
    multipos: function (p) { return has(p, /multiposici|mutiposici/i); }
  };


  // ---- categorias: al entrar desde una coleccion, el selector recomienda SOLO dentro de ella y hace su pregunta propia (foco)
  var COLS = {
    'cuchillos': { cat: 'general', tipo: 'F' }, 'navajas': { cat: 'general', tipo: 'N' },
    'cuchillos-caza': { cat: 'caza', uso: 'caza', tipo: 'F' }, 'navajas-caza': { cat: 'caza', uso: 'caza', tipo: 'N' },
    'cuchillos-bushcraft': { cat: 'bush', uso: 'bush', tipo: 'F' },
    'cuchillos-supervivencia': { cat: 'superv', uso: 'superv', tipo: 'F' }, 'navajas-supervivencia': { cat: 'superv', uso: 'superv', tipo: 'N' },
    'cuchillos-tacticos': { cat: 'tact', uso: 'tact', tipo: 'F' },
    'cuchillos-coleccion': { cat: 'colec', uso: 'colec', tipo: 'F' }, 'navajas-coleccion': { cat: 'colec', uso: 'colec', tipo: 'N' },
    'navajas-edc': { cat: 'diario', uso: 'diario', tipo: 'N' }, 'lanzadores': { cat: 'lanz', uso: 'lanz', tipo: 'F' }
  };
  var GRIP = /micarta|g-?10|caucho|canvas|yute|juma/i;
  var FOCO = {
    caza: { remate: function (p) { return /aguja|estilete|daga|lanza|bowie/i.test(p.punta) || (/clip/i.test(p.punta) && p.hoja >= 12); },
            desollar: function (p) { return /desollador|nesmuk/i.test(p.punta) || has(p, /desollador/i); },
            despiece: function (p) { return /drop|est[aá]ndar/i.test(p.punta) && p.hoja >= 8.5 && p.hoja <= 14; },
            menor: function (p) { return p.hoja <= 10; } },
    bush: { tallar: function (p) { return /escandinav|plano/i.test(p.afilado) && p.hoja <= 12; },
            lena: function (p) { return (p.grosor >= 4.5 && p.hoja >= 11) || has(p, /batoning/i); },
            fuego: function (p) { return has(p, /fuego|pedernal|chispa/i); } },
    superv: { resistente: function (p) { return p.grosor >= 4.5 && (p.ent || p.tipo === 'N'); },
              emergencia: function (p) { return has(p, /percutor|rompe|pedernal|espejo|reloj|sierra|kit/i); },
              compacto: function (p) { return p.hoja <= 10; } },
    tact: { resistente: function (p) { return p.grosor >= 4.5; }, agarre: function (p) { return GRIP.test(p.mangoTxt); },
            oscuro: function (p) { return /pavonad|pintura negra/i.test(p.acabado); } },
    colec: { bowie: function (p) { return /bowie/i.test(p.punta); }, monteria: function (p) { return /daga|lanza|aguja|estilete/i.test(p.punta); },
             nobles: function (p) { return /asta|ciervo|roseta|cocobolo|carnero|toro/i.test(p.mangoTxt); },
             moderno: function (p) { return /micarta|g-?10|juma|caucho|fibra|carbono/i.test(p.mangoTxt); } },
    diario: { ligera: function (p) { return p.peso && p.peso <= 80; }, robusta: function (p) { return p.hoja >= 8.5 && p.grosor >= 2.5; },
              tradicional: function (p) { return p.mango === 'nat'; }, agarre: function (p) { return GRIP.test(p.mangoTxt); } },
    lanz: { uno: function (p) { return !/pack/i.test(p.t); }, pack: function (p) { return /pack/i.test(p.t); } }
  };
  function catOf(a) { return a.col && COLS[a.col] ? COLS[a.col].cat : null; }
  function focoOk(p, a) { var c = catOf(a), f = c && FOCO[c] && FOCO[c][a.foco]; return !f || f(p); }
  // al entrar desde una coleccion se fijan uso y tipo (no se vuelven a preguntar)
  function applyCol(a) {
    var c = a.col && COLS[a.col]; if (!c) { delete a.col; return a; }
    a.tipo = c.tipo; if (c.uso) a.uso = c.uso;
    return a;
  }

  function sizeOf(p, bt) {
    if (p.hoja == null) return null;
    var b = BUCKETS[bt || p.tipo];
    return p.hoja <= b[0] ? 's' : (p.hoja <= b[1] ? 'm' : 'l');
  }
  // escala que ve el usuario: la de su tipo o una mixta si no lo ha elegido
  function bucketType(a) {
    if (a.tipo === 'N' || a.tipo === 'F') return a.tipo;
    if (a.uso === 'diario') return 'N';
    if (a.uso === 'bush' || a.uso === 'tact') return 'F';
    return 'X';
  }

  // 2 = es de esa categoria en la tienda · 1 = sirve tambien (criterio tecnico) · 0 = no
  function useFit(p, uso) {
    var u = p.uses;
    if (uso === 'lanz') return u.indexOf('lanz') >= 0 ? 2 : 0;
    if (u.indexOf('lanz') >= 0) return 0;
    if (!uso || uso === 'nose') return 1;
    if (u.indexOf(uso) >= 0) return 2;
    if (uso === 'diario') return (p.tipo === 'N' && p.hoja <= 9.5) ? 1 : 0;
    if (uso === 'bush') return (u.indexOf('superv') >= 0 && p.tipo === 'F') ? 1 : 0;
    if (uso === 'superv') return (u.indexOf('bush') >= 0 || (u.indexOf('tact') >= 0 && p.tipo === 'F')) ? 1 : 0;
    if (uso === 'tact') return (u.indexOf('superv') >= 0 && p.tipo === 'F') ? 1 : 0;
    if (uso === 'colec') return (PREMIUM_NAT.test(p.mangoTxt) && p.p >= 90) ? 1 : 0;
    return 0;
  }

  function inBudget(p, k) { var r = PRES[k]; return !r || (p.p >= r[0] && p.p < r[1]); }
  function budgetGap(p, k) { var r = PRES[k]; return !r ? 0 : (p.p < r[0] ? r[0] - p.p : (p.p >= r[1] ? p.p - r[1] : 0)); }
  function sizeOk(p, a) { return !a.tam || a.tam === 'igual' || a.uso === 'lanz' || sizeOf(p, bucketType(a)) === a.tam; }
  function detOk(p, a) { return !(a.det && a.det.length) || a.det.every(function (k) { return !DET[k] || DET[k](p); }); }

  function hard(p, a) {
    var t = a.tipo === 'N' || a.tipo === 'F' ? a.tipo : null, b = a.pres && a.pres !== 'igual' ? a.pres : null;
    return p.stock > 0 && (!a.col || (p.cols || []).indexOf(a.col) >= 0) && (a.col && catOf(a) !== 'general' ? true : useFit(p, a.uso) > 0) && focoOk(p, a) && (!t || p.tipo === t) && sizeOk(p, a) && (!b || inBudget(p, b)) && detOk(p, a);
  }

  /* Perfil en lenguaje llano (1-5), calculado SOLO con la ficha tecnica:
     filo = dureza HRC del acero · afilado = tipo de acero · resistencia = grosor + construccion
     ligereza = peso · cuidado = acero + material del mango */
  function perfil(p) {
    var hrc = p.hrc && p.hrc.length ? Math.max.apply(null, p.hrc) : null;
    var filo = hrc ? (hrc >= 60 ? 5 : hrc >= 59 ? 4.5 : hrc >= 57 ? 4 : hrc >= 54 ? 3 : 2) : ({ boh: 4.5, san: 4, mova: 3, '420': 2 }[p.acero] || 3);
    var afilado = { mova: 5, '420': 4.5, san: 4, boh: 3 }[p.acero] || 3;
    var g = p.grosor || 0;
    var res = g >= 4.8 ? 5 : g >= 4.5 ? 4.5 : g >= 3.8 ? 4 : g >= 3 ? 3 : g >= 2.5 ? 2.5 : 2;
    if (p.tipo === 'F' && p.ent) res += 0.5;
    if (p.tipo === 'N') res = Math.min(res, 4);
    var w = p.peso || 999, lig = w <= 60 ? 5 : w <= 100 ? 4 : w <= 160 ? 3 : w <= 260 ? 2 : 1;
    var cui = ({ '420': 4.5, boh: 4, san: 4, mova: 3.5 }[p.acero] || 3.5) + (p.mango === 'syn' ? 0.5 : p.mango === 'nat' ? -0.5 : 0);
    function c(x) { return Math.max(1, Math.min(5, Math.round(x * 2) / 2)); }
    return { filo: c(filo), afilado: c(afilado), resistencia: c(res), ligereza: c(lig), cuidado: c(cui) };
  }

  function prioScore(p, prio) {
    var f = perfil(p);
    switch (prio) {
      case 'filo': return (f.filo - 3) * 2;
      case 'afilar': return (f.afilado - 3) * 2;
      case 'mant': return (f.cuidado - 3) * 2;
      case 'agarre': return p.mango === 'syn' ? 4 : 0;
      case 'madera': return p.mango === 'nat' ? 4 : -1;
      case 'ligero': return (f.ligereza - 2.5) * 1.6;
      case 'robusto': return (f.resistencia - 3) * 2;
      default: return 0;
    }
  }

  // la ficha tecnica tambien cuenta segun el uso (punta, afilado, extras, cierre...)
  function useBonus(p, uso) {
    var b = 0;
    if (uso === 'caza') { if (/desollador/i.test(p.punta) || has(p, /desollador/i)) b += 1; if (/drop/i.test(p.punta)) b += 0.5; if (p.funda) b += 0.5; }
    if (uso === 'bush') { if (/escandinav/i.test(p.afilado)) b += 1.5; if (has(p, /fuego|pedernal|chispa|batoning/i)) b += 1; if (p.grosor >= 3.8) b += 0.5; }
    if (uso === 'superv') { if (p.grosor >= 4.5) b += 1; if (has(p, /percutor|rompe/i)) b += 0.5; if (p.ent) b += 0.5; if (has(p, /multiposici|mutiposici/i)) b += 0.5; }
    if (uso === 'diario') { if (p.cierre) b += 1.5; if (p.peso && p.peso <= 100) b += 1; if (has(p, /uñeta/i)) b += 0.5; }
    if (uso === 'tact') { if (p.grosor >= 4.5) b += 0.5; if (p.mango === 'syn') b += 0.5; }
    if (uso === 'colec') { if (PREMIUM_NAT.test(p.mangoTxt)) b += 1; if (/pulid/i.test(p.acabado)) b += 0.5; if (has(p, /lima y buril/i)) b += 1; }
    return b;
  }

  function score(p, a) {
    var fit = a.col && catOf(a) !== 'general' ? 2 : useFit(p, a.uso), s = fit === 2 ? 6 : 2;
    if (!a.tam || a.tam === 'igual') { if (sizeOf(p) === 'm') s += 1; }       // sin preferencia: lo versatil
    s += prioScore(p, a.prio) + useBonus(p, a.uso);
    if (a.quien === 'nuevo') {                                                 // primer cuchillo: seguro y agradecido
      if (p.tipo === 'N' && p.cierre) s += 1;
      if (p.funda) s += 0.5;
      if (p.hoja > 20) s -= 1.5;
    }
    if (a.quien === 'regalo') s += (p.funda ? 0.5 : 0) + (p.mango === 'nat' ? 0.5 : 0) + (p.rc ? 0.5 : 0);
    s += p.pop || 0;                                                          // orden 'mas vendidos' de la tienda (max 4)
    if (p.rc > 0 && p.r >= 4.5) s += 0.5;
    return s;
  }

  /* Devuelve: top (3 piezas de familias distintas), rest (resto que encaja, sin repetir familia del top) y exact (cuantas encajan).
     Si no hay 3 que cumplan todo, completa con "alternativas cercanas" marcadas en p._dev */
  function recommend(data, a, n) {
    n = n || 3;
    var b = a.pres && a.pres !== 'igual' ? a.pres : null, t = a.tipo === 'N' || a.tipo === 'F' ? a.tipo : null;
    var exact = data.filter(function (p) { return hard(p, a); }).map(function (p) { return { p: p, s: score(p, a), dev: [] }; });
    exact.sort(function (x, y) { return y.s - x.s; });
    var seen = {}, top = [], rest = [];
    exact.forEach(function (x) { if (top.length < n && !seen[x.p.fam]) { seen[x.p.fam] = 1; top.push(x); } else rest.push(x); });
    if (top.length < n) {
      var near = data.filter(function (p) { return p.stock > 0 && (!a.col || (p.cols || []).indexOf(a.col) >= 0) && (a.col && catOf(a) !== 'general' ? true : useFit(p, a.uso) > 0) && focoOk(p, a) && !hard(p, a) && !seen[p.fam]; }).map(function (p) {
        var dev = [], o = ['s', 'm', 'l'];
        if (!sizeOk(p, a)) { if (Math.abs(o.indexOf(sizeOf(p, bucketType(a))) - o.indexOf(a.tam)) !== 1) return null; dev.push('tam'); }
        if (b && !inBudget(p, b)) { if (budgetGap(p, b) > 30) return null; dev.push('pres'); }
        if (t && p.tipo !== t) dev.push('tipo');
        if (!detOk(p, a)) dev.push('det');
        if (!focoOk(p, a)) dev.push('foco');
        return { p: p, s: score(p, a) - 3 * dev.length - budgetGap(p, b) / 10, dev: dev };
      }).filter(Boolean);
      near.sort(function (x, y) { return y.s - x.s; });
      near.forEach(function (x) { if (top.length < n && !seen[x.p.fam]) { seen[x.p.fam] = 1; top.push(x); } });
    }
    return { top: top, rest: rest, exact: exact.length };
  }

  // flujo adaptativo: solo se pregunta lo que aporta
  function steps(a) {
    var c = catOf(a);
    if (c && c !== 'general') {                       // categoria concreta: su pregunta propia
      var s0 = ['quien', 'foco'];
      if (a.quien === 'exp' && c !== 'lanz') s0.push('det');
      return s0.concat(['pres']);
    }
    var s = ['quien', 'uso'];
    if (a.uso === 'lanz') return s.concat(['pres']);
    if (!c && ['caza', 'superv', 'colec', 'nose'].indexOf(a.uso) >= 0) s.push('tipo');
    s.push('tam', 'prio');
    if (a.quien === 'exp') s.push('det');
    s.push('pres');
    return s;
  }

  // hay al menos una pieza con stock si se elige esta opcion? (la interfaz oculta las que no)
  function available(data, a, key, value) {
    var b = {}; for (var k in a) b[k] = a[k];
    if (key === 'det') b.det = (a.det || []).concat([value]); else b[key] = value;
    for (var i = 0; i < data.length; i++) if (hard(data[i], b)) return true;
    return false;
  }

  // ---- normaliza lo que emite templates/collection.kf-data.liquid (valores en espanol = logica estable)
  var USO = { 'cuchillos-caza': 'caza', 'navajas-caza': 'caza', 'cuchillos-bushcraft': 'bush', 'cuchillos-supervivencia': 'superv',
    'navajas-supervivencia': 'superv', 'cuchillos-tacticos': 'tact', 'navajas-edc': 'diario', 'cuchillos-coleccion': 'colec',
    'navajas-coleccion': 'colec', 'lanzadores': 'lanz' };
  var LOCKS = ['Bloqueo trasero', 'Pistón', 'Bloqueo de liner', 'Bloqueo central', 'Muelle con palanquilla'];
  var NAT = /olivo|ciervo|nogal|cocobolo|asta|abedul|carnero|roseta|estamina/i;
  function cl(x) { return String(x == null ? '' : x).replace(/ /g, ' ').replace(/\s+/g, ' ').trim(); }
  function nm(x) { if (x == null || x === '') return null; var v = parseFloat(String(x).replace(',', '.')); return isNaN(v) ? null : v; }
  // modelo = numero de la referencia (208-L, 208-M... = Ness Wolf); si no hay, los "hermanos" enlazados o el handle
  function fam(r) { var m = /^(\d{2,4})/.exec(cl(r.sku)); return m ? 'ref' + m[1] : (r.f || r.h); }
  function prep(r, rank) {
    var s = r.s || {}, c = r.c || [];
    if (c.indexOf('hachas') >= 0 || c.indexOf('cuchillos-jamoneros') >= 0) return null;
    var uses = [];
    c.forEach(function (h) { var u = USO[h]; if (u && uses.indexOf(u) < 0) uses.push(u); });
    if (uses.indexOf('lanz') >= 0) uses = ['lanz'];
    var a = cl(s.acero).toLowerCase();
    var mtxt = cl(s.mango) || cl(r.mc), ft = cl(s.material_funda), vir = cl(s.cruceta_virola), ci = cl(s.sistema_de_cierre).toLowerCase();
    var cierre = ''; LOCKS.forEach(function (l) { if (l.toLowerCase() === ci) cierre = l; });
    return {
      id: r.id, t: cl(r.t), h: r.h, url: r.u, ref: cl(r.sku) || cl(s.nombre_pieza), imgs: (r.im || []).filter(Boolean),
      p: r.p / 100, pmax: r.pm / 100, cmp: (r.cmp || 0) / 100, cents: r.p,
      tipo: c.indexOf('navajas') >= 0 ? 'N' : 'F', uses: uses, fam: fam(r), rank: rank, pop: 4 * Math.max(0, 1 - rank / 50),
      stock: r.a ? Math.max(r.q || 0, 1) : 0, qty: r.q || 0, tracked: !!r.tr, r: r.r, rc: r.rc || 0,
      hoja: nm(s.longitud_de_hoja), mangoL: nm(s.longitud_de_mango), total: nm(s.longitud_total), grosor: nm(s.grosor_de_hoja),
      ancho: nm(s.ancho_de_pala), peso: nm(s.peso_pieza), pesoFunda: nm(s.peso_funda),
      afilado: cl(s.hoja), acabado: cl(s.acabado_de_la_hoja), punta: cl(s.punta_de_la_hoja),
      acero: /hler/.test(a) ? 'boh' : /sandvik/.test(a) ? 'san' : /420/.test(a) ? '420' : /molibdeno/.test(a) ? 'mova' : '',
      aceroTxt: cl(s.acero), hrc: (cl(s.dureza_del_acero).match(/\d+/g) || []).slice(0, 2).map(Number),
      cierre: cierre, virola: /^enteriz/i.test(vir) ? '' : vir, ent: /enter/i.test(s.estructura || ''), estructura: cl(s.estructura),
      anclaje: cl(s.anclaje_del_mango), mango: NAT.test(mtxt + ' ' + (r.mc || '')) ? 'nat' : (mtxt ? 'syn' : ''), mangoTxt: mtxt,
      funda: /incluida/i.test(ft) || r.fi === true, fundaTxt: ft.replace(/\s*\((incluida|opcional)\)/ig, ''), fundaOpc: /opcional/i.test(ft),
      extras: (s.extras || []).map(cl).filter(Boolean), cols: c
    };
  }
  // r: lista cruda en el orden "mas vendidos" -> piezas normalizadas con su puesto
  function prepAll(list) { var out = [], rank = 0; list.forEach(function (r) { var p = prep(r, rank); if (p) { out.push(p); rank++; } }); return out; }

  var api = { prepAll: prepAll, COLS: COLS, FOCO: FOCO, catOf: catOf, applyCol: applyCol, recommend: recommend, steps: steps, available: available, perfil: perfil, sizeOf: sizeOf, bucketType: bucketType,
              useFit: useFit, hard: hard, inBudget: inBudget, BUCKETS: BUCKETS, PRES: PRES, DET: DET };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.KFEngine = api;
})(this);
